/* GOBIND OFFICIAL theme JS — vanilla, no dependencies */
(function () {
  'use strict';

  /* ---------- Mega menu toggle ---------- */
  function initMenu() {
    var toggles = document.querySelectorAll('[data-menu-toggle]');
    var panel = document.querySelector('[data-menu-panel]');
    var backdrop = document.querySelector('[data-menu-backdrop]');
    if (!panel) return;

    var open = false;
    function setOpen(next) {
      open = next;
      panel.classList.toggle('menu-open', open);
      if (backdrop) backdrop.classList.toggle('hidden', !open);
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.documentElement.classList.toggle('menu-is-open', open);
      window.dispatchEvent(new Event('header:update'));
    }
    toggles.forEach(function (t) {
      t.addEventListener('click', function () { setOpen(!open); });
    });
    if (backdrop) backdrop.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* ---------- Transparent header (homepage): solid after scroll or with open menu ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header-transparent]');
    if (!header) return;
    var transparentClasses = ['text-white', 'bg-transparent', 'border-transparent'];
    var solidClasses = ['text-ink', 'bg-white', 'border-sage'];

    function update() {
      var solid = window.scrollY > 40 || document.documentElement.classList.contains('menu-is-open');
      transparentClasses.forEach(function (c) { header.classList.toggle(c, !solid); });
      solidClasses.forEach(function (c) { header.classList.toggle(c, solid); });
    }
    window.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
    window.addEventListener('header:update', update);
    update();
  }

  /* ---------- Collection category filter (in-page, filters on product_type) ---------- */
  function initCollectionFilter() {
    var bar = document.querySelector('[data-collection-filter]');
    var grid = document.querySelector('[data-cat-grid]');
    if (!bar || !grid) return;

    var buttons = Array.prototype.slice.call(bar.querySelectorAll('[data-cat-filter]'));
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-cat-item]'));
    var emptyState = document.querySelector('[data-cat-empty]');
    var resetButton = document.querySelector('[data-cat-reset]');
    var pagination = document.querySelector('[data-cat-pagination]');
    var sortField = bar.querySelector('[data-cat-sort-field]');
    if (!buttons.length) return;

    var activeClasses = ['text-black', 'border-b', 'border-black', 'pb-0.5'];
    var idleClasses = ['text-neutral-500', 'hover:text-black'];

    function matches(item, filter) {
      if (filter === '__all__') return true;
      if (filter === '__new__') return item.getAttribute('data-product-new') === 'true';
      return (item.getAttribute('data-product-type') || '').toLowerCase() === filter.toLowerCase();
    }

    function apply(filter, pushUrl) {
      var visible = 0;
      items.forEach(function (item) {
        var show = matches(item, filter);
        item.classList.toggle('hidden', !show);
        // Items hidden at load never trigger the IntersectionObserver, so reveal them here.
        if (show) {
          item.classList.add('revealed');
          visible++;
        }
      });

      buttons.forEach(function (button) {
        var isActive = button.getAttribute('data-cat-filter') === filter;
        activeClasses.forEach(function (c) { button.classList.toggle(c, isActive); });
        idleClasses.forEach(function (c) { button.classList.toggle(c, !isActive); });
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (emptyState) {
        emptyState.classList.toggle('hidden', visible > 0);
        emptyState.classList.toggle('flex', visible === 0);
      }
      // Pagination pages are not filtered, so hide it while a category is active.
      if (pagination) pagination.classList.toggle('hidden', filter !== '__all__');
      if (sortField) sortField.value = filter === '__all__' ? '' : filter;

      if (pushUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (filter === '__all__') url.searchParams.delete('category');
        else url.searchParams.set('category', filter);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function filterFromUrl() {
      var requested = new URLSearchParams(window.location.search).get('category');
      if (!requested) return null;
      var match = buttons.filter(function (b) {
        return b.getAttribute('data-cat-filter').toLowerCase() === requested.toLowerCase();
      })[0];
      return match ? match.getAttribute('data-cat-filter') : null;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        apply(button.getAttribute('data-cat-filter'), true);
      });
    });
    if (resetButton) {
      resetButton.addEventListener('click', function () { apply('__all__', true); });
    }

    // Default to the first tab (NEW ARRIVALS when present, otherwise ALL), like the old /shop page.
    apply(filterFromUrl() || buttons[0].getAttribute('data-cat-filter'), false);
  }

  /* ---------- Man/woman toggle on the product page ---------- */
  function initGenderToggle() {
    var bar = document.querySelector('[data-gender-toggle]');
    if (!bar) return;
    var buttons = Array.prototype.slice.call(bar.querySelectorAll('[data-gender-option]'));
    var galleries = Array.prototype.slice.call(document.querySelectorAll('[data-gender-gallery]'));
    var texts = Array.prototype.slice.call(document.querySelectorAll('[data-gender-text]'));
    if (!buttons.length || !galleries.length) return;

    var activeClasses = ['text-black', 'border-b', 'border-black', 'pb-0.5'];
    var idleClasses = ['text-neutral-500', 'hover:text-black'];

    function select(view) {
      galleries.forEach(function (g) {
        var show = g.getAttribute('data-gender-gallery') === view;
        g.classList.toggle('hidden', !show);
        // A gallery hidden at load never triggers the IntersectionObserver.
        if (show) g.classList.add('revealed');
      });
      texts.forEach(function (t) {
        t.classList.toggle('hidden', t.getAttribute('data-gender-text') !== view);
      });
      buttons.forEach(function (b) {
        var isActive = b.getAttribute('data-gender-option') === view;
        activeClasses.forEach(function (c) { b.classList.toggle(c, isActive); });
        idleClasses.forEach(function (c) { b.classList.toggle(c, !isActive); });
        b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      // The carousel measured zero width while hidden, so let it recalculate.
      window.dispatchEvent(new Event('resize'));
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () { select(b.getAttribute('data-gender-option')); });
    });
    select(buttons[0].getAttribute('data-gender-option'));
  }

  /* ---------- Product recommendations (fetched via the recommendations endpoint) ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.querySelector('[data-rec-grid]');
          if (grid && grid.children.length > 0) {
            el.innerHTML = grid.outerHTML;
          } else {
            var wrapper = el.closest('[data-recommendations-wrapper]');
            if (wrapper) wrapper.remove();
          }
        })
        .catch(function () { /* leave hidden on failure */ });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initScrollReveal() {
    var els = document.querySelectorAll('.scroll-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-reveal-delay') || 0;
          setTimeout(function () { entry.target.classList.add('revealed'); }, delay);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Horizontal carousels (home product carousel, product gallery) ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      var counter = root.querySelector('[data-carousel-counter]');
      if (!track) return;

      function slideWidth() {
        var slide = track.querySelector('[data-carousel-slide]');
        if (!slide) return track.clientWidth;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return slide.getBoundingClientRect().width + gap;
      }
      function index() {
        return Math.round(track.scrollLeft / slideWidth());
      }
      function count() {
        return track.querySelectorAll('[data-carousel-slide]').length;
      }
      function update() {
        var i = index();
        if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 4);
        if (next) next.toggleAttribute('disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
        if (counter) counter.textContent = (i + 1) + ' / ' + count();
        root.querySelectorAll('[data-carousel-dot]').forEach(function (dot, di) {
          dot.classList.toggle('border-ink', di === i);
          dot.classList.toggle('border-transparent', di !== i);
        });
      }
      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
      });
      root.querySelectorAll('[data-carousel-dot]').forEach(function (dot, di) {
        dot.addEventListener('click', function () {
          track.scrollTo({ left: di * slideWidth(), behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity() {
    document.querySelectorAll('[data-qty]').forEach(function (root) {
      var input = root.querySelector('input[name="quantity"], input[data-qty-input]');
      if (!input) return;
      root.querySelectorAll('[data-qty-minus]').forEach(function (b) {
        b.addEventListener('click', function () {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      root.querySelectorAll('[data-qty-plus]').forEach(function (b) {
        b.addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 1) + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Variant (size) buttons → hidden select ---------- */
  function initVariantButtons() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
      var idInput = root.querySelector('[data-variant-id]');
      var addButton = root.querySelector('[data-add-to-cart]');
      var addLabel = addButton ? addButton.querySelector('[data-add-to-cart-label]') : null;
      var priceEl = root.querySelector('[data-product-price]');
      var variants;
      try {
        variants = JSON.parse(root.querySelector('[data-variants-json]').textContent);
      } catch (e) {
        return;
      }

      function selectedOptions() {
        var opts = [];
        root.querySelectorAll('[data-option-index]').forEach(function (group) {
          var active = group.querySelector('[data-option-value].is-selected');
          opts[parseInt(group.getAttribute('data-option-index'), 10)] = active ? active.getAttribute('data-option-value') : null;
        });
        return opts;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return opts[i] === val; });
        });
      }

      function update() {
        var variant;
        if (root.querySelectorAll('[data-option-index]').length === 0) {
          // Product without options has exactly one variant, so there is nothing to pick.
          variant = variants[0] || null;
        } else {
          var opts = selectedOptions();
          var allChosen = opts.every(function (o) { return o !== null && o !== undefined; });
          variant = allChosen ? findVariant(opts) : null;
        }

        if (variant) {
          if (idInput) idInput.value = variant.id;
          if (priceEl && variant.price_formatted) priceEl.textContent = variant.price_formatted;
          if (addButton) {
            addButton.disabled = !variant.available;
            if (addLabel) {
              addLabel.textContent = variant.available
                ? addButton.getAttribute('data-label-add')
                : addButton.getAttribute('data-label-sold-out');
            }
          }
        } else if (addButton) {
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = addButton.getAttribute('data-label-select');
        }
      }

      root.querySelectorAll('[data-option-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-option-index]');
          group.querySelectorAll('[data-option-value]').forEach(function (b) {
            b.classList.remove('is-selected', 'bg-ink', 'text-cream');
          });
          btn.classList.add('is-selected', 'bg-ink', 'text-cream');
          update();
        });
      });

      update();
    });
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-accordion-item]');
        var content = item.querySelector('[data-accordion-content]');
        var isOpen = item.classList.toggle('accordion-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (content) content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : '0';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initHeader();
    initCollectionFilter();
    initGenderToggle();
    initRecommendations();
    initScrollReveal();
    initCarousels();
    initQuantity();
    initVariantButtons();
    initAccordions();
  });
})();
